import React from "react";
import { Col } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PublicLayout from "components/PublicLayout";

const FailPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <PublicLayout>
      <Col lg="6" md="12" className="mt-4 mx-auto">
        <div className="card mt-2 public-card">
          <div className="card-body status-panel" role="alert">
            <i
              className="simple-icon-close status-icon text-danger"
              aria-hidden="true"
            />
            <h2 className="mb-2">{t("paymentFailedTitle")}</h2>
            <p className="text-muted mb-4">{t("paymentFailedBody")}</p>
            <button
              type="button"
              className="btn btn-primary btn-lg mb-3"
              onClick={() => navigate("/")}
            >
              {t("tryAgain")}
            </button>
            <p className="mb-0 text-small">
              {t("needHelp")}{" "}
              <a href="tel:+998712300103">+998 71 230 01 03</a> ·{" "}
              <a href="https://t.me/tktonlinebot">@tktonlinebot</a>
            </p>
          </div>
        </div>
      </Col>
    </PublicLayout>
  );
};

export default FailPage;
